<script setup lang="ts">
interface Props {
  actionDisabled?: boolean;
  actionLabel: string;
  actionTestId?: string;
  caption: string;
  captionClass: string;
  captionMaxWidth: string;
  captionTestId?: string;
  preserveCaptionLines?: boolean;
  rootClass: string;
  rootTestId: string;
  title: string;
}

withDefaults(defineProps<Props>(), {
  actionDisabled: false,
  actionTestId: undefined,
  captionTestId: undefined,
  preserveCaptionLines: false,
});

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const emit = defineEmits<{
  action: [];
}>();
</script>

<template>
  <div
    class="KioskTerminalMessage"
    :class="rootClass"
    :data-testid="rootTestId"
    :style="{ '--KioskTerminalMessage--caption-max-width': captionMaxWidth }"
  >
    <h1 class="kiosk-title">{{ title }}</h1>
    <div
      class="KioskTerminalMessage__caption kiosk-subtitle"
      :class="[captionClass, { 'kiosk-pre-line': preserveCaptionLines }]"
      :data-testid="captionTestId"
    >
      {{ caption }}
    </div>
    <button
      class="kiosk-button"
      :data-testid="actionTestId"
      :disabled="actionDisabled"
      type="button"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.KioskTerminalMessage {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.KioskTerminalMessage__caption {
  font-size: 1.8rem;
  line-height: 2.5rem;
  margin: 2rem 0 3rem;
  max-width: var(--KioskTerminalMessage--caption-max-width);
  text-align: center;
}
</style>
